import { render, staticRenderFns } from "./BB-annotating.vue?vue&type=template&id=21a4c50f&scoped=true&"
import script from "./BB-annotating.vue?vue&type=script&lang=js&"
export * from "./BB-annotating.vue?vue&type=script&lang=js&"
import style0 from "./BB-annotating.vue?vue&type=style&index=0&id=21a4c50f&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a4c50f",
  null
  
)

export default component.exports